import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess';
import { hasSchemaACL } from '@frontend/auth-helpers';
import { useAppFlagStore } from '@frontend/shared';

export const useCheckCanSendMessages = (locationId: string) => {
  const { featureFlags } = useAppFlagStore();

  return featureFlags[locationId]?.get('nwx:messaging-integrated-messaging-fe-acl-enforcement')?.value
    ? !!hasSchemaACL(locationId, Permission.SMS_INBOX_MANAGE)
    : true;
};
